import { createRouter as createTanStackRouter } from "@tanstack/react-router"

import { ErrorFallback } from "@/components/ErrorFallback"
import { NotFoundPage } from "@/components/not-found/NotFoundPage"
import type { SiteHeaderVariant } from "@/routes/-components/site/siteHeaderVariant"

import { routeTree } from "./route-tree.gen"

export function getRouter() {
  const router = createTanStackRouter({
    routeTree,

    scrollRestoration: true,
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
    defaultErrorComponent: ErrorFallback,
    defaultNotFoundComponent: NotFoundPage,
    trailingSlash: "never",
  })

  return router
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>
  }

  interface StaticDataRouteOption {
    header?: SiteHeaderVariant
  }
}
